import React from "react";
import AxiosConfig from "axiosConfig";
import * as CONSTANT from "constants/text"
import "./FriendGroupChildrenToggle.css";
import BorderedButton from "components/General/Form/CustomButton/BorderedButton";
import ButtonGroup from "react-bootstrap/ButtonGroup";

//reference to bootstrap API Doc: https://react-bootstrap.netlify.app/components/button-group/

class FriendGroupChildrenToggle extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            hasChildren: null,
        }
    }

    /******************************************************************
    * Check if this user has any children when the component mounts.
    */
    componentDidMount() {
       let obj = this;
       AxiosConfig.get("profile/has_children/").then(function (response) {
          obj.setState((prevState) => ({
             hasChildren: response.data["has_children"],
          }));
       });
    }

    /*
    * Render the Friends, Groups tabs and optionally render the Children tab is the user has children.
    * render each tab depending on the activeTab prop.
    */
    renderFriendGroupChildrenToggle(props){
        return (
            <ButtonGroup className = "toggle_container">
                {props.activeTab === CONSTANT.FRIENDS? (
                    <BorderedButton
                        buttonClassName = "background_dark_bright_blue"
                        borderColor = "#30afc8"
                        title = {CONSTANT.FRIENDS}
                        textClassName = "text_small text_white"
                    />
                    ):(
                    <BorderedButton
                        handleOnClick = {() => window.location.assign("/friends")}
                        buttonClassName = "background_white"
                        borderColor = "#30afc8"
                        title = {CONSTANT.FRIENDS}
                        textClassName = "text_small text_dark_bright_blue"
                    />
                    )
                }

                {props.activeTab === CONSTANT.GROUPS? (
                    <BorderedButton
                        buttonClassName = "background_dark_bright_blue"
                        borderColor = "#30afc8"
                        title = {CONSTANT.GROUPS}
                        textClassName = "text_small text_white"
                    />
                    ):(
                    <BorderedButton
                        handleOnClick = {() => window.location.assign("/groups")}
                        buttonClassName = "background_white border_dark_bright_blue"
                        borderColor = "#30afc8"
                        title = {CONSTANT.GROUPS}
                        textClassName = "text_small text_dark_bright_blue"
                    />

                    )

                }
                {this.state.hasChildren === "true"? (
                  props.activeTab === CONSTANT.CHILDREN? (
                    <BorderedButton
                        buttonClassName = "background_dark_bright_blue"
                        borderColor = "#30afc8"
                        title = {CONSTANT.CHILDREN}
                        textClassName = "text_small text_white"
                    />
                    ):(
                    <BorderedButton
                        handleOnClick = {() => window.location.assign("/manage-child-tribe")}
                        buttonClassName = "background_white"
                        borderColor = "#30afc8"
                        title = {CONSTANT.CHILDREN}
                        textClassName = "text_small text_dark_bright_blue"
                    />
                    )
               ):(null)}
            </ButtonGroup>
        );
    }

    render(){
        return (
            <div>
                {this.state.hasChildren === null?
                  (null):(this.renderFriendGroupChildrenToggle(this.props))
                }
            </div>
        );
    }
}


export default FriendGroupChildrenToggle;